export const ID = 'f5c7032e-9da3-46cc-a1d7-7487e19e62d6';

export const NAME = 'StorageMart Search Header';
